<script>
  import { X } from 'lucide-svelte';

  export let iconClass = '';
</script>

<X class={iconClass} />